export default __webpack_public_path__ + "static/media/lead_app.7fa5e1e0.PNG";